export { useIsNavigatorEssentials as useIsNavigatorStandard } from "./useIsNavigatorStandard";
